import L from "leaflet";
import { useEffect, useRef, useState } from "react";
import { MapContainer, Marker, TileLayer, useMapEvent, useMapEvents } from "react-leaflet";
import 'leaflet/dist/leaflet.css';

export default function LocationInput({
  /*   returnPositions,
   */ longitude,
  latitude,
  setData,
  data,
}) {
  const [position, setPosition] = useState({ lat: 52.1326, lng: 5.2913 });
  useEffect(() => {
    if (latitude && longitude) {
      setPosition({ lat: Number(latitude), lng: Number(longitude) });
    }
  }, [longitude, latitude]);
  function LocationMarker() {
    const [bbox, setBbox] = useState([]);
    const iconPerson = new L.Icon({
      iconUrl: "/images/map-marker (1).svg",
      iconRetinaUrl: "/images/map-marker (1).svg",
      iconAnchor: null,
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null,
      iconSize: new L.Point(30, 40),
      className: "leaflet-div-icon",
    });
    const map = useMapEvents({
      click() {
        map.locate();
      },
      locationfound(e) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      },
    });

    return position === null ? null : (
      <Marker icon={iconPerson} position={position}>
        {/*  <div>height</div> */}
      </Marker>
    );
  }
  function SetViewOnClick({ animateRef }) {
    const map = useMapEvent("click", (e) => {
      setPosition(e.latlng);
      map.setView(e.latlng, map.getZoom(), {
        animate: animateRef.current || false,
      });
    });

    return null;
  }
  const animateRef = useRef(false);
  useEffect(() => {
    setData({ ...data, lat: position.lat, lon: position.lng });
  }, [position]);
  return (
    <div className="MapMainCom">
      <MapContainer
        center={{ lat: 52.1326, lng: 5.2913 }}
        zoom={13}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker />
        <SetViewOnClick animateRef={animateRef} />
      </MapContainer>
    </div>
  );
}
